import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
    events: [],
    inspectorEvents: [],
    filters: {
        eventGroups: {
            sdk: true,
            gameplay: true,
            ads: true,
            measure: true,
            leaderboard: true,
        },
    }
};

const gameEventsSlice = createSlice({
    name: 'gameEvents',
    initialState,
    reducers: {
        setInitialState: (state) => {
            state.events = initialState.events;
        },
        setGameEvent: (state, action) => {
            state.events.push(action.payload);
        },
        setInspectorEvent: (state, action) => {
            state.inspectorEvents.push(action.payload);
        },
        setGameEvents: (state, action) => {
            state.events = action.payload;
        },
        clearGameEvents: (state) => {
            state.events = initialState.events;
        },
        removeInspectorEvent: (state, action) => {
            state.inspectorEvents = state.inspectorEvents.filter((event) => event.event !== action.payload.event);
        },
        toggleEventGroupFilter: (state, action) => {
            const groupName = action.payload;
            state.filters.eventGroups[groupName] = !state.filters.eventGroups[groupName];
        },
        setAllEventGroupFilters: (state, action) => {
            const enabled = action.payload;
            for (const key of Object.keys(state.filters.eventGroups)) {
                state.filters.eventGroups[key] = enabled;
            }
        },
        setOnlyEventGroupFilter: (state, action) => {
            const groupKey = action.payload;
            for (const key of Object.keys(state.filters.eventGroups)) {
                state.filters.eventGroups[key] = key === groupKey;
            }
        },
    },
});

export const {
    setInitialState,
    setGameEvent,
    setInspectorEvent,
    setGameEvents,
    clearGameEvents,
    toggleEventGroupFilter,
    setAllEventGroupFilters,
    setOnlyEventGroupFilter,
    removeInspectorEvent,
} = gameEventsSlice.actions;

export const selectGameEvents = createSelector(
    (state) => state.gameEvents,
    (gameEvents) => gameEvents.events,
);

export const selectInspectorEvents = createSelector(
    (state) => state.gameEvents,
    (gameEvents) => gameEvents.inspectorEvents,
);

export const selectEventGroupFilters = createSelector(
    (state) => state.gameEvents,
    (gameEvents) => gameEvents.filters.eventGroups,
);

export default gameEventsSlice.reducer;
